import { useEffect, useState, useContext } from "react";
import { Div } from "../../Styles/Styled";
import TextField from "@mui/material/TextField";
import InputMask from "../../manualPackets/react-input-mask";
import { GestorContext } from "../../store/GestorStore";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ModalProduto from "../../Components/ModalProds";
import { CircularProgress } from "@mui/material";
import {
  FaRoute,
  FaUser,
  FaEllipsisH,
  FaMoneyBillWave,
  FaArrowCircleLeft,
  FaPhone,
  FaPhoneAlt,
  FaBuilding,
  FaMotorcycle,
  FaSdCard,
  FaCreditCard,
  FaTrash,
} from "react-icons/fa";

import { MdPix } from "react-icons/md";

import { scrollIntoView, polyfill } from "seamless-scroll-polyfill";

import cepPromisse from "cep-promise";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Radio,
  Typography,
  Grid,
  RadioGroup,
  FormControl,
  FormHelperText,
  FormControlLabel,
  Box,
  Fab,
  List,
  Container,
  Button,
  CssBaseline,
  InputAdornment,
  MenuItem,
  Select,
} from "@mui/material";
import DetailComponent from "../../Components/DetailComponent";
import api from "../../services/api";
import Util from "../../Util";
import { Colors, NOME_EMPRESA } from "../../config";

polyfill({ forcePolyfill: true });

interface IProd {
  id?: number;
  chave: number;
  descricao: string;
  preco_venda: number;
  grupo1: string;
  grupo2: string;
  grupo3: string;
  quantidade: number;
  observacao: string;
  tipo: string;
  kits?: any[];
  extras: IExtraProd[];
  picture: string;
  observacao_produto?: string;
}

interface IExtraProd {
  chave: number;
  descricao: string;
  qme: number;
  quantidade: number;
  ordem: number;
  preco_venda: number;
  chave_kit: number;
}

interface ICondicao {
  chave: number;
  descricao: string;
}

interface IRotas {
  chave: number;
  descricao: string;
  valor_frete: number;
}

export default function CheckOut() {
  polyfill({ forcePolyfill: true });
  const Gestor = useContext(GestorContext);
  const history = useNavigate();
  const [forma_de_pagamento, setFormaDePagamento] = useState("");
  const [tipo_de_entrega, setTipoDeEntrega] = useState<Number | undefined>(1);
  const [cep, setCep] = useState("");
  const [rota_selecionada, setRotaSelecionada] = useState("");
  const [prodDetail, setProdDetail] = useState<IProd | null>(null);
  const [condicoes, setCondicoes] = useState<ICondicao[]>([]);
  const [rotas, setRotas] = useState<IRotas[]>([]);
  const [loading, setLoading] = useState(false);
  const [cidade, setCidade] = useState("");
  const [complemento, setComplemento] = useState("");
  const [page, setPage] = useState(1);
  const [bairro, setBairro] = useState("");
  const [nome, setNome] = useState("");
  const [celular, setCelular] = useState("");
  const [numero, setNumero] = useState<Number | undefined>();
  const [rua, setRua] = useState("");
  const [uf, setUF] = useState("");
  const [prodsCart, setProdsCart] = useState<IProd[]>([]);

  useEffect(() => {
    const win = window;

    function Prevent(e: any) {
      e.preventDefault();
    }
    if (win.addEventListener) {
      //Firefox only
      win.addEventListener("DOMMouseScroll", Prevent, true);
    }
    window.onscroll = Prevent;
    const slider = document.getElementById("slider");
    if (slider) {
      slider.scrollLeft = 0;
    }
  }, []);

  const changePage = async (box: string) => {
    const page2 = page + 1;
    if (page2 === 2) {
      if (validations_adress) {
      } else {
        alert("Verifique os campos");
        return;
      }
    }
    if (page2 > 3) {
      const element = document.getElementById(`box${1}`);
      if (element) await scrollIntoViewPromise(element).then(() => {});
      setPage(1);
      return;
    }

    const element = document.getElementById(`box${page2}`);
    if (element) await scrollIntoViewPromise(element).then(() => {});
    setPage(page2);
    return;
  };

  const validation_cell = celular && celular?.length === 16 ? true : false;

  const validation_name = nome && nome?.length >= 3 ? true : false;

  const valitation_cep = cep && cep?.length === 8 ? true : false;

  const valitation_numero = numero && `${numero}`?.length >= 1 ? true : false;

  const valitation_rua = rua && rua?.length > 3 ? true : false;

  const valitation_bairro =
    rota_selecionada && `${rota_selecionada}`?.length >= 1 ? true : false;

  const valitation_cidade = cidade && cidade?.length > 3 ? true : false;

  const valitation_uf = uf && uf.length > 1 ? true : false;

  const validations = [];
  validations.push(validation_cell);
  validations.push(validation_name);
  validations.push(valitation_cep);
  validations.push(valitation_numero);
  validations.push(valitation_rua);
  validations.push(valitation_bairro);
  validations.push(valitation_cidade);
  validations.push(valitation_uf);

  const validations_adress = validations.reduce((t, a) => t && a);

  const handleCompra = async () => {
    if (loading === true) return;
    fazerPedido();
  };

  const fazerPedido = async () => {
    if (loading === true) return;
    setLoading(true);
    try {
      const phone = Util.removerCaracteresEspeciais(celular);
      const result = await api.post("pedido", {
        nome: Util.removeAcentos(nome),
        telefone: phone,
        rua: Util.removeAcentos(rua),
        estado: uf,
        cep: cep,
        bairro: Util.removeAcentos(
          rotas?.filter((e) => `${e?.chave}` == rota_selecionada)[0].descricao
        ),
        cidade: Util.removeAcentos(cidade),
        numero,
        complemento,
        pedidos: prodsCart,
        condicao: forma_de_pagamento,
        tipo_de_entrega: tipo_de_entrega,
      });
      setLoading(false);
      alert("pedido feito com sucesso!");
      await Gestor?.CleanCart();
      history("/");
      console.log(result);
    } catch (err: any) {
      console.log(err);
      setLoading(false);
      if (err?.message) {
        alert(`${err?.response?.data?.message}`);
        return;
      }
      alert("erro ao fazer pedido!");
    }
  };

  const handleCelular = async (texto: string) => {
    setCelular(texto);
    console.log(texto.length);
    console.log(Util.removerCaracteresEspeciais(texto));
    const phone = Util.removerCaracteresEspeciais(texto);
    console.log(phone?.length);
    if (phone && phone?.length >= 11) {
      try {
        const result = await api.get(`/phone/${phone}`);
        const data = result.data;
        setRua(data?.rua);
        setComplemento(data?.complemento);
        setCidade(data?.cidade);
        setNumero(data?.numero);
        setNome(data?.nome);
        setCep(data?.cep);
        setUF(data?.estado);
        if (
          rotas.filter((e) =>
            Util.removeAcentos(data?.bairro?.toString().toUpperCase()).includes(
              e?.descricao.toString().toUpperCase()
            )
          )[0]
        ) {
          const rota = rotas?.filter((e) =>
            Util.removeAcentos(data?.bairro?.toString().toUpperCase()).includes(
              e?.descricao.toString().toUpperCase()
            )
          )[0];
          setRotaSelecionada(`${rota?.chave}`);
        }
      } catch (err) {}
    }
  };

  const handleCep = async (texto: string) => {
    setCep(texto);
    if (texto.length === 8) {
      const cepPesquisa: any = texto
        ?.split("")
        ?.filter((e) => e != "" && e != "-")
        ?.join("");
      await cepPromisse(cepPesquisa).then((res) => {
        setRua(res.street);
        setBairro(res.neighborhood);
        if (res.neighborhood === "") {
          setRotaSelecionada("");
        } else if (
          rotas?.filter((e) =>
            Util.removeAcentos(
              res.neighborhood?.toString().toUpperCase()
            ).includes(e?.descricao.toString().toUpperCase())
          )[0]
        ) {
          const rota = rotas?.filter((e) =>
            Util.removeAcentos(
              res.neighborhood?.toString().toUpperCase()
            ).includes(e?.descricao.toString().toUpperCase())
          )[0];
          setRotaSelecionada(`${rota?.chave}`);
        } else {
          setRotaSelecionada("");
        }
        setUF(res.state);
        setCidade(res.city);
      });
    }
  };

  const getCondicoes = async () => {
    try {
      const result = await api.get("condicoes");
      setCondicoes(result.data);
      if (result.data[0]) {
        setFormaDePagamento(result.data[0].descricao);
      }
    } catch (err) {
      alert("erro ao pegar condicoes de pagamento, recarregue a pagina");
    }
  };

  const scrollIntoViewPromise = async (
    node: Element,
    options?: ScrollIntoViewOptions
  ) => {
    polyfill({ forcePolyfill: true });
    scrollIntoView(node, {
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
    return new Promise((resolve) => {
      const intersectionObserver = new IntersectionObserver((entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setTimeout(() => {
            resolve(true);
            intersectionObserver.unobserve(node);
          }, 100);
        }
      });
      intersectionObserver.observe(node);
    });
  };

  const focus = async (id: string) => {
    setPage(1);
    const element = document.getElementById(`box${1}`);
    console.log(element);
    const teste = document.querySelector(`#${id}`);
    if (!teste) return;
    await scrollIntoViewPromise(teste).then((res) => element?.scrollIntoView());
  };

  const getRotas = async () => {
    try {
      const result = await api.get("rotas");
      setRotas(result.data);
    } catch (err) {
      alert("erro ao pegar rotas de entrega, recarregue a pagina");
    }
  };

  const handlePage = async () => {
    if (page === 1) {
      history("/");
    } else {
      const teste = page - 1;
      setPage(teste);
      const element = document.getElementById(`box${teste}`);
      if (!element) return;
      await scrollIntoViewPromise(element).then(() => {});
    }
  };

  useEffect(() => {
    document.title = NOME_EMPRESA;
    if (Gestor) {
      setProdsCart(Gestor.state.carrinho);
    }
    getCondicoes();
    getRotas();
  }, []);

  useEffect(() => {
    if (Gestor) {
      setProdsCart(Gestor.state.carrinho);
    }
  }, [Gestor]);

  useEffect(() => {
    if (tipo_de_entrega === 0) {
      // quando é Retirada na loja, carregar endereco
      setCidade("Rio Grande");
      setBairro("Cidade Nova");
      setRotaSelecionada("1");
      setRua("Rua Marechal Deodoro");
      setUF("RS");
      setNumero(507);
      setCep("96211480");
    }
    if (tipo_de_entrega === 1) {
      setCidade("");
      setBairro("");
      setRua("");
      setUF("");
      setNumero(undefined);
      setCep("");
    }
  }, [tipo_de_entrega]);

  return (
    <Container
      disableGutters={true}
      sx={{
        backgroundColor: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
      maxWidth={false}
    >
      {prodDetail && (
        <ModalProduto
          open={false}
          {...prodDetail}
          onPressClose={() => setProdDetail(null)}
        />
      )}
      <Grid container>
        <Grid
          item
          id={"headerCarrinho"}
          bgcolor={Colors.header}
          xs={12}
          position={"relative"}
          justifyContent={"center"}
          alignItems={"center"}
          display={"flex"}
          height={`${window.innerHeight * 0.13}px`}
        >
          <div
            onClick={() => handlePage()}
            style={{
              position: "absolute",
              top: "35%",
              left: 25,
              height: 35,
              width: 35,
              borderRadius: 20,
              background: Colors.header,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <FaArrowCircleLeft size={30} color={Colors.icon} />
          </div>
          <div
            style={{
              backgroundColor: Colors.headerCircleColor,
              height: window.innerHeight * 0.1,
              width: window.innerHeight * 0.1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "50%",
            }}
          >
            <img
              onClick={() => history("/")}
              src="./logo.png"
              style={{
                maxHeight: window.innerHeight * 0.08,
                objectFit: "contain",
                cursor: "pointer",
              }}
            />
          </div>
        </Grid>
      </Grid>
      <Div Width={"100%"} Height={"88vh"} overflow="hidden" row id="slider">
        <Grid
          id="box1"
          container
          display={"flex"}
          xs={12}
          sx={{
            minWidth: "100vw",
            maxWidth: "100vw",
            paddingBottom: 10,
            paddingTop: 2,
          }}
          overflow={"scroll"}
        >
          <Grid item xs={0.5} />
          <Grid item xs={11}>
            <Grid item xs={12} sx={{ marginBottom: 2 }} id="nome">
              <Typography color={"black"} textAlign={"center"} fontSize={20}>
                Dados Pessoais
              </Typography>
            </Grid>

            <Grid xs={12} sx={{ marginBottom: 2 }}>
              <InputMask
                mask="(99) 9 9999-9999" // Format you need implemented
                value={celular}
                onChange={(e: any) => handleCelular(e.target.value)}
                placeholder="(99) 9 9999-9999"
                alwaysShowMask={false}
                name="cellNumber"
                required
              >
                {() => (
                  <TextField
                    fullWidth
                    type="tel"
                    error={!validation_cell}
                    helperText={
                      !validation_cell
                        ? "Celular Deve ser Preenchido ex: (99) 9 9999-9999"
                        : ""
                    }
                    placeholder="Celular"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <FaPhoneAlt size={20} color="##fcfcfc" />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              </InputMask>
            </Grid>

            <Grid xs={12}>
              <TextField
                fullWidth
                placeholder="Nome Completo"
                value={nome}
                error={!validation_name}
                helperText={
                  !validation_name ? "Nome deve ter pelo menos 3 letras" : ""
                }
                sx={{ borderColor: "d50000" }}
                onChange={(e) => setNome(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <FaUser size={20} color="##fcfcfc" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} sx={{ marginBottom: 2, marginTop: 2 }}>
              <Typography color={"black"} textAlign={"center"} fontSize={20}>
                Forma de entrega
              </Typography>
            </Grid>

            <Grid id="entrega">
              <Select
                labelId="demo-simple-select-label"
                placeholder="Forma de Entrega"
                fullWidth
                value={tipo_de_entrega}
                onChange={(e) => {
                  setTipoDeEntrega(parseInt(`${e.target.value}`));
                }}
              >
                <MenuItem value={0}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <FaBuilding
                      size={20}
                      color="##fcfcfc"
                      style={{ marginRight: 10 }}
                    />
                    <div>Retirar na loja </div>
                  </div>
                </MenuItem>
                <MenuItem value={1}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <FaMotorcycle
                      size={20}
                      color="##fcfcfc"
                      style={{ marginRight: 10 }}
                    />
                    <div>Tele-Entrega </div>
                  </div>
                </MenuItem>
              </Select>
            </Grid>

            <Grid id="endereco">
              <CssBaseline />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Box
                  component="form"
                  noValidate
                  onSubmit={(e: any) => {
                    e.preventDefault();
                  }}
                  sx={{ mt: 3 }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={6} sm={6}>
                      <TextField
                        name="cep"
                        disabled={tipo_de_entrega === 0}
                        type="tel"
                        helperText={
                          !valitation_cep
                            ? "CEP é obrigatório para tele entrega"
                            : ""
                        }
                        error={!valitation_cep}
                        value={cep}
                        fullWidth
                        id="testaa"
                        label="CEP"
                        onChange={(e) => handleCep(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                      <TextField
                        fullWidth
                        disabled={tipo_de_entrega === 0}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        error={!valitation_numero}
                        helperText={
                          !valitation_numero
                            ? 'Numero é Obrigatório, caso não tenha coloque "1"'
                            : ""
                        }
                        id="numero"
                        label="Numero"
                        name="numero"
                        defaultValue={numero}
                        value={numero ? numero : ""}
                        onChange={(e) => setNumero(parseInt(e.target.value))}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        error={!valitation_rua}
                        helperText={
                          !valitation_rua
                            ? "Rua é um campo obrigatorio, caso nao tenha, coloque sem Rua ou escreva uma referencia"
                            : ""
                        }
                        fullWidth
                        id="rua"
                        disabled={tipo_de_entrega === 0}
                        label="Rua"
                        value={rua}
                        onChange={(e) => setRua(e.target.value)}
                        name="rua"
                        autoComplete="address"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl fullWidth error={!valitation_bairro}>
                        <Select
                          labelId="demo-simple-select-label2"
                          id="demo-simple-select2"
                          error={!valitation_bairro}
                          placeholder="Bairro"
                          fullWidth
                          disabled={tipo_de_entrega === 0}
                          value={rota_selecionada}
                          onChange={(e) => {
                            setRotaSelecionada(`${e.target.value}`);
                          }}
                        >
                          {rotas &&
                            rotas[0] &&
                            rotas.map((e) => {
                              return (
                                <MenuItem value={e?.chave}>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div> {e?.descricao} </div>
                                  </div>
                                </MenuItem>
                              );
                            })}
                        </Select>
                        {!valitation_bairro && (
                          <FormHelperText>
                            Bairro é Obrigatorio, caso não tenha o seu, a
                            empresa não oferece{" "}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        error={!valitation_cidade}
                        fullWidth
                        name="Cidade"
                        value={cidade}
                        helperText={
                          !valitation_cidade
                            ? "Cidade é obrigatorio para realizar o pedido"
                            : ""
                        }
                        disabled={tipo_de_entrega === 0}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={(e) => setCidade(e.target.value)}
                        label="Cidade"
                        id="city"
                        autoComplete="city"
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        error={!valitation_uf}
                        fullWidth
                        helperText={
                          !valitation_uf
                            ? "Estado é Obrigatorio para o pedido"
                            : ""
                        }
                        name="Estado"
                        label="Estado"
                        value={uf}
                        disabled={tipo_de_entrega === 0}
                        onChange={(e) => setUF(e.target.value)}
                        id="estado"
                        autoComplete="estado"
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        required
                        fullWidth
                        name="Complemento"
                        label="Complemento"
                        value={complemento}
                        onChange={(e) => setComplemento(e.target.value)}
                        id="password"
                        disabled={tipo_de_entrega === 0}
                        autoComplete="new-password"
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Grid>

            <Grid
              xs={12}
              direction={"row"}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              sx={{
                marginTop: 5,
                marginBottom: 1,
              }}
            >
              <Button
                variant="contained"
                onClick={() => changePage("")}
                sx={{
                  backgroundColor: "white",
                  borderColor: "black",
                  borderWidth: 2,
                  borderStyle: "solid",
                  width: "90vw",
                  color: "black",
                  ":hover": {
                    bgcolor: "white", //
                    color: "black",
                  },
                }}
              >
                Continuar
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={0.5} />
        </Grid>
        <Grid
          id="box2"
          container
          display={"flex"}
          flexDirection={"column"}
          sx={{
            minWidth: "100vw",
            maxWidth: "100vw",
            overflow: "scroll",
          }}
        >
          <Grid
            item
            xs={12}
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            style={{
              maxHeight: "5%",
              overflow: "scroll",
              marginTop: 20,
            }}
          >
            <Typography color={"black"} fontSize={24}>
              Carrinho
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            style={{
              maxHeight: "74%",
              overflow: "scroll",
            }}
          >
            {prodsCart.map((e) => {
              const extra = e?.extras
                ?.filter((f: any) => f?.ordem === 99)
                ?.reduce((c, b) => {
                  return c + b?.preco_venda * b?.quantidade;
                }, 0);
              console.log(extra);
              const valor =
                (parseFloat(`${e.preco_venda}`) + extra) * e.quantidade;
              return (
                <div
                  onClick={() => setProdDetail(e)}
                  style={{
                    width: "90%",
                    flexDirection: "column",
                    position: "relative",
                    display: "flex",
                    backgroundColor: Colors.backgroundHeader,
                    flexWrap: "nowrap",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: 10,
                    padding: 5,
                    marginBottom: 10,
                    border: "2px solid white",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      flexDirection: "row",
                      display: "flex",
                      flexWrap: "nowrap",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <img
                      style={{
                        width: "25%",
                        maxHeight: 100,
                        objectFit: "contain",
                        borderRadius: 5,
                      }}
                      onError={(e: any) => (e.target.src = "./notfound.png")}
                      src={e.picture}
                    />
                    <div
                      style={{
                        width: "35%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          color: Colors.icon,
                          fontSize: "0.75em",
                          textAlign: "left",
                        }}
                      >
                        {e.descricao}
                      </div>
                      <div
                        style={{
                          marginTop: 5,
                          color: Colors.icon,
                          fontSize: "0.75em",
                          textAlign: "left",
                        }}
                      >
                        QTD: {e.quantidade}{" "}
                        {e?.extras &&
                          e?.extras[0] &&
                          `Adicinais: ${e?.extras?.length}`}
                      </div>
                    </div>
                    <div
                      style={{
                        marginTop: 5,
                        color: Colors.icon,
                        fontSize: "0.85em",
                        textAlign: "left",
                      }}
                    >
                      R$
                      {new Intl.NumberFormat("pt-BR", {
                        minimumFractionDigits: 2,
                      }).format(valor)}
                    </div>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                    }}
                  >
                    <FaTrash size={"0.85em"} color="white" />
                  </div>
                </div>
              );
            })}
          </Grid>
          <Grid
            item
            xs={12}
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            style={{
              maxHeight: "5%",
              overflow: "scroll",
            }}
          >
            <Typography color={"black"} fontSize={24}>
              Total:{" R$"}
              {new Intl.NumberFormat("pt-BR", {
                minimumFractionDigits: 2,
              }).format(
                prodsCart.reduce((a, u) => {
                  const extra = u?.extras
                    ?.filter((f: any) => f?.ordem === 99)
                    ?.reduce((c, b) => {
                      return c + b?.preco_venda * b?.quantidade;
                    }, 0);
                  console.log(extra);
                  const valor =
                    (parseFloat(`${u.preco_venda}`) + extra) * u.quantidade;
                  return a + valor;
                }, 0)
              )}
            </Typography>
          </Grid>
          <Grid
            xs={12}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            sx={{
              marginTop: 1,
              marginBottom: 1,
              flexBasis: "auto",
            }}
          >
            <Button
              variant="contained"
              onClick={() => changePage("")}
              sx={{
                backgroundColor: "white",
                borderColor: "black",
                borderWidth: 2,
                borderStyle: "solid",
                width: "90vw",
                color: "black",
                ":hover": {
                  bgcolor: "white", // theme.palette.primary.main
                  color: "black",
                },
              }}
            >
              Proximo
            </Button>
          </Grid>
        </Grid>
        <Grid
          id="box3"
          display={"flex"}
          alignItems={"center"}
          flexDirection={"column"}
          sx={{
            minWidth: "100vw",
            maxWidth: "100vw",
            overflow: "scroll",
            paddingTop: 1,
          }}
        >
          <Typography color="black"> Resumo de compra </Typography>

          <DetailComponent
            title="Nome"
            onClick={() => {
              focus("nome");
            }}
            icon={<FaUser color="black" />}
            value={nome}
            EndIcon={<FaEllipsisH color="black" />}
          />

          <DetailComponent
            onClick={() => {
              focus("entrega");
            }}
            title="Tipo de Entrega"
            icon={<FaRoute color="black" />}
            value={
              tipo_de_entrega === 0
                ? "Retirada na Loja"
                : tipo_de_entrega === 1
                ? "Tele-Entrega"
                : ""
            }
            EndIcon={<FaEllipsisH color="black" />}
          />
          <Grid item xs={12} sx={{ marginBottom: 0, marginTop: 2 }}>
            <Typography color={"black"} textAlign={"center"}>
              Forma de pagamento
            </Typography>
          </Grid>
          <Grid container xs={11} sx={{ maxHeight: "75px" }}>
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label2"
                id="demo-simple-select2"
                style={{
                  maxHeight: "45px",
                  border: "black 1px solid",
                  borderRadius: 0,
                }}
                placeholder="Forma de pagamento"
                IconComponent={() => (
                  <FaEllipsisH
                    color="black"
                    size={22}
                    style={{ marginRight: "5%" }}
                  />
                )}
                fullWidth
                value={forma_de_pagamento}
                onChange={(e) => {
                  console.log(e.target.value);
                  setFormaDePagamento(`${e.target.value}`);
                }}
              >
                {condicoes &&
                  condicoes[0] &&
                  condicoes.map((e) => {
                    const condicao = e.descricao
                      .toLocaleUpperCase()
                      .includes("DINHEIRO")
                      ? 0
                      : e.descricao.toLocaleUpperCase().includes("CARTAO")
                      ? 1
                      : e.descricao.toLocaleUpperCase().includes("CARTÃO")
                      ? 1
                      : e.descricao.toLocaleUpperCase().includes("DEBITO")
                      ? 1
                      : e.descricao.toLocaleUpperCase().includes("CREDITO")
                      ? 1
                      : e.descricao.toLocaleUpperCase().includes("CRÉDITO")
                      ? 1
                       : e.descricao.toLocaleUpperCase().includes("BANRI")
                      ? 1
                      : e.descricao.toLocaleUpperCase().includes("CARTÂO")
                      ? 1
                      : e.descricao.toLocaleUpperCase().includes("PIX")
                      ? 2
                      : 0;
                    return (
                      <MenuItem value={e.descricao}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {condicao === 0 && (
                            <FaMoneyBillWave
                              size={20}
                              color="black"
                              style={{ marginRight: 10 }}
                            />
                          )}
                          {condicao === 1 && (
                            <FaCreditCard
                              size={20}
                              color="black"
                              style={{ marginRight: 10 }}
                            />
                          )}
                          {condicao === 2 && (
                            <MdPix
                              size={20}
                              color="black"
                              style={{ marginRight: 10 }}
                            />
                          )}
                          <div> {e.descricao} </div>
                        </div>
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </Grid>

          <DetailComponent
            title="Endereço"
            onClick={() => {
              focus("endereco");
            }}
            icon={null}
            value={`${rua}, ${numero ? numero : ""}, ${
              rotas?.filter((e) => `${e?.chave}` === rota_selecionada)[0]
                ? rotas?.filter((e) => `${e?.chave}` === rota_selecionada)[0]
                    .descricao
                : ""
            }`}
            EndIcon={<FaEllipsisH color="black" />}
          />

          <Typography color="black" sx={{ marginTop: 1 }}>
            Resumo De Pagamento
          </Typography>
          <Grid xs={11} container flexBasis={"60%"}>
            <Grid xs={6} item>
              <Typography color="black">SubTotal</Typography>
            </Grid>

            <Grid xs={6} item>
              <Typography color="black" textAlign={"right"}>
                R${" "}
                {new Intl.NumberFormat("pt-BR", {
                  minimumFractionDigits: 2,
                }).format(
                  prodsCart.reduce((a, u) => {
                    const extra = u?.extras
                      ?.filter((f: any) => f?.ordem === 99)
                      ?.reduce((c, b) => {
                        return c + b?.preco_venda * b?.quantidade;
                      }, 0);

                    return a + (u.preco_venda + extra) * u.quantidade;
                  }, 0)
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid xs={11} container flexBasis={"60%"}>
            <Grid xs={6} item>
              <Typography color="black">Tele-Entrega</Typography>
            </Grid>

            <Grid xs={6} item>
              <Typography color="black" textAlign={"right"}>
                R${" "}
                {tipo_de_entrega === 0
                  ? "0,00"
                  : new Intl.NumberFormat("pt-BR", {
                      minimumFractionDigits: 2,
                    }).format(
                      rotas?.filter(
                        (e) => `${e?.chave}` === rota_selecionada
                      )[0]
                        ? rotas?.filter(
                            (e) => `${e?.chave}` === rota_selecionada
                          )[0].valor_frete
                        : 0
                    )}
              </Typography>
            </Grid>
          </Grid>

          <Grid xs={11} container flexBasis={"60%"}>
            <Grid xs={6} item>
              <Typography color="black">Total</Typography>
            </Grid>

            <Grid xs={6} item>
              <Typography
                color="black"
                textAlign={"right"}
                style={{ textDecorationLine: "underline" }}
              >
                R${" "}
                {new Intl.NumberFormat("pt-BR", {
                  minimumFractionDigits: 2,
                }).format(
                  prodsCart.reduce((a, u) => {
                    const extra = u?.extras
                      ?.filter((f: any) => f?.ordem === 99)
                      ?.reduce((c, b) => {
                        return c + b?.preco_venda * b?.quantidade;
                      }, 0);
                    return a + (u.preco_venda + extra) * u.quantidade ;
                  }, 0) +
                    (tipo_de_entrega === 0
                      ? 0
                      : rotas?.filter(
                          (e) => `${e?.chave}` === rota_selecionada
                        )[0]
                      ? parseFloat(
                          `${
                            rotas?.filter(
                              (e) => `${e?.chave}` === rota_selecionada
                            )[0].valor_frete
                          }`
                        )
                      : 0)
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            xs={12}
            direction={"row"}
            display={"flex"}
            flexBasis={"60%"}
            alignItems={"center"}
            justifyContent={"center"}
            sx={{
              marginTop: 1,
              marginBottom: 1,
            }}
          >
            <Button
              variant="contained"
              onClick={() => handleCompra()}
              sx={{
                backgroundColor: "white",
                borderColor: "black",
                borderWidth: 2,
                borderStyle: "solid",
                width: "90vw",
                color: "black",
                ":hover": {
                  bgcolor: "white", // theme.palette.primary.main
                  color: "black",
                },
              }}
            >
              {loading ? (
                <CircularProgress size={25} color="inherit" />
              ) : (
                "Finalizar Compra"
              )}
            </Button>
          </Grid>
        </Grid>
      </Div>
    </Container>
  );
}
